export const environment = process.env;
